import { useVisibleBudget } from '../context/VisibleItemFinancialsContext';
import type { ItemsTableRow } from '../types';
import { OrgCurrencyCell } from './OrgCurrencyCell';

export const BudgetCell = ({ row }: { row: ItemsTableRow }) => (
  <OrgCurrencyCell amount={useVisibleBudget(row.id)} />
);
